module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "所属省市",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "类型",
      "value": _vm.row.clubleixing
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "等级",
      "value": _vm.row.bgrade
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "申报单位",
      "value": _vm.row.shenbaodanwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "俱乐部名称",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "授权编号",
      "value": _vm.row.bcode
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场地面积",
      "value": _vm.row.chandimianji
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "拟注册运动员人数",
      "value": _vm.row.yundongyuanrenshu
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位地址",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "详细地址",
      "value": _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场地照片"
    }
  }, _vm._l((_vm.row.changdipic), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "申报表"
    }
  }, _vm._l((_vm.row.shenbaozip), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('van-divider', [_vm._v("负责人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "负责人姓名",
      "value": _vm.row.nickname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人身份证号",
      "value": _vm.row.certificatenumber
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人邮箱",
      "value": _vm.row.email
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人手机",
      "value": _vm.row.phone
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("联系人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "联系人姓名",
      "value": _vm.row.contactsname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人身份证号",
      "value": _vm.row.contactscertificatenumber
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人邮箱",
      "value": _vm.row.contactsemail
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人手机",
      "value": _vm.row.contactsphone
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("审核信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "验收图片证明"
    }
  }, _vm._l((_vm.row.yanshou_pic), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "验收表上传"
    }
  }, _vm._l((_vm.row.yanshoubiao_pic), function(item) {
    return _c('a', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "50px"
      },
      attrs: {
        "src": item.url
      }
    })])
  }), 0), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "备案审核"
    }
  }, [(_vm.row.registstatus == 0) ? _c('div', [_vm._v("未提交")]) : (_vm.row.registstatus == 1) ? _c('div', [_vm._v("待审核")]) : (_vm.row.registstatus == 2) ? _c('div', [_vm._v("审核通过")]) : (_vm.row.registstatus == 3) ? _c('div', [_vm._v("审核失败")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "拒绝审核理由",
      "value": _vm.row.registstatusdes
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "管理员备注",
      "value": _vm.row.clubadminnote
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402ba1dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/club/ClubDetail.vue
// module id = 2344
// module chunks = 0